export default "__VITE_ASSET__Wx7th1zD__"